import {useState, useCallback} from 'react'
import {ChevronDownIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from './CollapsiblePanel.module.css'

interface CollapsiblePanelProps {
  /** The heading text displayed in the panel header */
  heading: string
  /** Content rendered inside the collapsible body */
  children: React.ReactNode
  /** Additional class name applied to the panel's `<section>` element */
  className?: string
  /** Whether the panel is initially expanded (default: true) */
  defaultOpen?: boolean
}

/** A reusable collapsible section with a heading row and chevron toggle */
export function CollapsiblePanel({heading, children, className, defaultOpen = true}: CollapsiblePanelProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  return (
    <section className={className}>
      <h3 className={styles.heading}>
        <button type="button" className={styles.headingRow} aria-expanded={isOpen} onClick={toggle}>
          <span>{heading}</span>
          <ChevronDownIcon size={16} className={clsx(styles.chevron, !isOpen && styles.chevronCollapsed)} />
        </button>
      </h3>
      {isOpen && children}
    </section>
  )
}
